/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sovereign_Domain_LockedInputs */

const en_sovereign_domain_locked = /** @type {(inputs: Sovereign_Domain_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Domain Locked`)
};

const es_sovereign_domain_locked = /** @type {(inputs: Sovereign_Domain_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio Sovereign bloqueado`)
};

const fr_sovereign_domain_locked = /** @type {(inputs: Sovereign_Domain_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domaine Sovereign verrouillé`)
};

const de_sovereign_domain_locked = /** @type {(inputs: Sovereign_Domain_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign-Domain gesperrt`)
};

const ja_sovereign_domain_locked = /** @type {(inputs: Sovereign_Domain_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereignドメインがロックされました`)
};

const zh_sovereign_domain_locked = /** @type {(inputs: Sovereign_Domain_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 域名已锁定`)
};

const ar_sovereign_domain_locked = /** @type {(inputs: Sovereign_Domain_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نطاق Sovereign مقفول`)
};

const id_sovereign_domain_locked = /** @type {(inputs: Sovereign_Domain_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain Sovereign Terkunci`)
};

const it_sovereign_domain_locked = /** @type {(inputs: Sovereign_Domain_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio Sovereign Bloccato`)
};

const ru_sovereign_domain_locked = /** @type {(inputs: Sovereign_Domain_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Домен Sovereign заблокирован`)
};

const pt_sovereign_domain_locked = /** @type {(inputs: Sovereign_Domain_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domínio Sovereign Bloqueado`)
};

const ko_sovereign_domain_locked = /** @type {(inputs: Sovereign_Domain_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 도메인 잠김`)
};

/**
* | output |
* | --- |
* | "Sovereign Domain Locked" |
*
* @param {Sovereign_Domain_LockedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sovereign_domain_locked = /** @type {((inputs?: Sovereign_Domain_LockedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sovereign_Domain_LockedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sovereign_domain_locked(inputs)
	if (locale === "es") return es_sovereign_domain_locked(inputs)
	if (locale === "fr") return fr_sovereign_domain_locked(inputs)
	if (locale === "de") return de_sovereign_domain_locked(inputs)
	if (locale === "ja") return ja_sovereign_domain_locked(inputs)
	if (locale === "zh") return zh_sovereign_domain_locked(inputs)
	if (locale === "ar") return ar_sovereign_domain_locked(inputs)
	if (locale === "id") return id_sovereign_domain_locked(inputs)
	if (locale === "it") return it_sovereign_domain_locked(inputs)
	if (locale === "ru") return ru_sovereign_domain_locked(inputs)
	if (locale === "pt") return pt_sovereign_domain_locked(inputs)
	return ko_sovereign_domain_locked(inputs)
});